import { atom } from "jotai";
import {
  autoLayoutAtom,
  emitAiPredictionOutputEventAtom,
  zslFeedbackPredictionIdAtom,
  uuid,
} from "@zapier/canvas-state";
import { isJsonString, removeIndexingFromZsl, systems } from "../utils";
import { streamedZslAtom } from "./streamedZslAtom";
import { aiPromptAtom } from "./aiPromptAtom";
import { zslToCanvasPostCommand } from "./zslToCanvasPostCommand";
import { isModifyPromptOpenAtom } from "./isModifyPromptOpenAtom";
import { outlineAtom } from "./outlineAtom";

export const renderZslToCanvasCommand = atom(null, async (get, set) => {
  const zsl = get(streamedZslAtom);
  if (!zsl) return;

  const modifiedZsl = removeIndexingFromZsl(zsl);
  const prompt = get(aiPromptAtom);
  const isModifyPromptOpen = get(isModifyPromptOpenAtom);

  // We want a consistent prediction ID when modifying the prompt
  if (!isModifyPromptOpen) {
    const prediction_id = uuid();
    set(zslFeedbackPredictionIdAtom, prediction_id);

    const outline = get(outlineAtom);
    const isHardcoded = systems.some((role) =>
      role.systems.some(
        (system) =>
          system.prompt.includes(prompt) || prompt.includes(system.prompt),
      ),
    );

    let outlineObject: object | string;
    if (isJsonString(outline)) {
      outlineObject = JSON.parse(outline);
    } else {
      outlineObject = outline;
    }

    set(emitAiPredictionOutputEventAtom, {
      prediction_id,
      correlation_id: null,
      prediction_json_input: JSON.stringify({ prompt, isHardcoded }),
      prediction_json_output: JSON.stringify({
        outline: outlineObject,
        zsl: modifiedZsl,
      }),
      prediction_source: "canvas.creation",
    });
  }

  const nodesAndEdges = await set(
    zslToCanvasPostCommand,
    JSON.stringify(modifiedZsl),
  );

  if (nodesAndEdges) {
    // This ensures nodes are rendered with height and width for auto-layout to work
    setTimeout(() => {
      const { isSuccess } = set(autoLayoutAtom);

      if (isSuccess) {
        set(isModifyPromptOpenAtom, false);
      }
    }, 500);
  }
});

renderZslToCanvasCommand.debugLabel = "renderZslToCanvasCommand";
